import { CFType, FormValues, RequestFieldsValues } from "../types"

export const formatRequestData = ({
  CashFlowTypes,
  LoanLimit,
  OutstandingBalance,
  PaymentFreq,
  RecoveryLags,
  AssessmentDate,
  CCF,
  Contract_IR,
  LGD,
  NextPaymentDate,
  ObligorRating,
  Segment,
  Stage_Regular,
}: RequestFieldsValues) => {
  return {
    request_data: {
      inputs: {
        AssessmentDate,
        CashFlowTypes,
        CCF,
        Contract_IR,
        LGD,
        LoanLimit,
        NextPaymentDate,
        ObligorRating,
        OutstandingBalance,
        PaymentFreq,
        RecoveryLags,
        Segment,
        Stage_Regular,
      },
    },
    request_meta: {
      version_id: "638de46a-6e92-41bf-ab8f-47266d17800d",
      transaction_date: "2022-09-02T09:24:17.356Z",
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
    },
  }
}

export const prepareEditableJsonData = () => {
  return {
    request_data: {
      inputs: {
        AssessmentDate: "2023-02-24",
        NextPaymentDate: "2023-03-31",
        CashFlowTypes: "Balloon",
        CCF: "55.1",
        Contract_IR: "22.3",
        LGD: "80.95",
        LoanLimit: "1200000",
        ObligorRating: "A",
        OutstandingBalance: "325000",
        PaymentFreq: "12",
        RecoveryLags: "12",
        Segment: "2",
        Stage_Regular: "2",
      },
    },
    request_meta: {
      version_id: "638de46a-6e92-41bf-ab8f-47266d17800d",
      transaction_date: "2022-09-02T09:24:17.356Z",
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
    },
  }
}

export const formatFormValues = (values: FormValues) => {
  return {
    CashFlowTypes: values.CashFlowTypes.value as CFType,
    LoanLimit: Number(values.LoanLimit),
    OutstandingBalance: Number(values.OutstandingBalance),
    PaymentFreq: Number(values.PaymentFreq.value),
    RecoveryLags: Number(values.RecoveryLags),
    AssessmentDate: String(values.AssessmentDate),
    NextPaymentDate: String(values.NextPaymentDate),
    CCF: Number(values.CCF) / Math.pow(100, 1),
    Contract_IR: Number(values.Contract_IR) / Math.pow(100, 1),
    LGD: Number(values.LGD) / Math.pow(100, 1),
    ObligorRating: String(values.ObligorRating.value),
    Segment: Number(values.Segment.value),
    Stage_Regular: Number(values.Stage_Regular.value),
  }
}

export const prepareJsonDataForRequest = (jsonData: any) => {
  return {
    ...jsonData,
    request_data: {
      ...jsonData.request_data,
      inputs: {
        ...jsonData.request_data.inputs,
        CCF: Number(jsonData.request_data.inputs.CCF) / Math.pow(100, 1),
        Contract_IR: Number(jsonData.request_data.inputs.Contract_IR) / Math.pow(100, 1),
        LGD: Number(jsonData.request_data.inputs.LGD) / Math.pow(100, 1),
        LoanLimit: Number(jsonData.request_data.inputs.LoanLimit),
        OutstandingBalance: Number(jsonData.request_data.inputs.OutstandingBalance),
        PaymentFreq: Number(jsonData.request_data.inputs.PaymentFreq),
        RecoveryLags: Number(jsonData.request_data.inputs.RecoveryLags),
        Segment: Number(jsonData.request_data.inputs.Segment),
        Stage_Regular: Number(jsonData.request_data.inputs.Stage_Regular),
      },
    },
  }
}

